<template>
  <div class="main-left-top">
    <div class="main-left-header" @click="toIndexPath">
      <span class="line"></span>
      {{ $t("apiDoc.极兔API简介") }}
    </div>

    <div class="main-left-aside">
      <el-menu
        router
        ref="openApiMenu"
        active-text-color="#C31422"
        :default-active="activeIndex == '/apiDoc/index' ? null : activeIndex"
        class="api-menu-vertical"
      >
        <div class="search-box">
          <el-input
            v-model="searchKeyword"
            :placeholder="$t('apiDoc.搜索菜单')"
            clearable
            prefix-icon="el-icon-search"
          ></el-input>
        </div>
        <!-- 使用过滤后的菜单数据 -->
        <template v-if="filteredAsideList.length">
          <el-submenu
            v-for="(menuItem, menuIndex) in filteredAsideList"
            :index="`menu${menuIndex}`"
            :key="menuIndex"
          >
            <template slot="title">
              <span>{{ $t(`apiDoc.${menuItem.title}`) }}</span>
            </template>
            <el-menu-item
              v-for="subItem in menuItem.subTitle"
              :key="subItem.path"
              :index="subItem.path"
            >
              {{ $t(`apiDoc.${subItem.title}`) }}
            </el-menu-item>
          </el-submenu>
        </template>
        <!-- 空状态提示 -->
        <div v-else class="empty-state">
          {{ $t("apiDoc.未找到匹配的菜单项") }}
        </div>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchKeyword: "", // 新增搜索关键词
      activeIndex: this.$route.path,
      asideList: [
        {
          title: "基础资料",
          subTitle: [
            {
              title: "创建货品",
              path: "/apiDoc/item/create"
            },
            {
              title: "查询货品",
              path: "/apiDoc/item/query"
            },
            {
              title: "查询备货仓库",
              path: "/apiDoc/other/queryInventoryWarehouse"
            }
          ]
        },
        {
          title: "入库",
          subTitle: [
            {
              title: "创建入库单",
              path: "/apiDoc/order/inbound/create"
            },
            {
              title: "查询入库单",
              path: "/apiDoc/order/inbound/query"
            },
            {
              title: "入库单状态回传",
              path: "/apiDoc/order/inbound/return"
            },
            {
              title: "合单预报",
              path: "/apiDoc/other/combinedOrderForecast"
            }
          ]
        },
        {
          title: "库存",
          subTitle: [
            {
              title: "库存查询",
              path: "/apiDoc/inventory/query"
            },
            {
              title: "库存快照查询",
              path: "/apiDoc/inventory/snapshotQuery"
            },
            {
              title: "库存异动回传",
              path: "/apiDoc/inventory/return"
            }
          ]
        },
        {
          title: "出库",
          subTitle: [
            {
              title: "创建出库单",
              path: "/apiDoc/order/outbound/create"
            },
            {
              title: "查询出库单",
              path: "/apiDoc/order/outbound/query"
            },
            {
              title: "出库单状态回传",
              path: "/apiDoc/order/outbound/return"
            }
          ]
        },
        {
          title: "取消",
          subTitle: [
            {
              title: "单据取消",
              path: "/apiDoc/order/cancel"
            }
          ]
        },
        {
          title: "全程跟踪",
          subTitle: [
            {
              title: "物流轨迹查询",
              path: "/apiDoc/other/queryTrajectory"
            }
          ]
        },
        {
          title: "设备",
          subTitle: [
            {
              title: "设备登录",
              path: "/apiDoc/other/login"
            },
            {
              title: "称重设备上传重量",
              path: "/apiDoc/other/uploadWeight"
            },
            {
              title: "容器绑定",
              path: "/apiDoc/other/containerBind"
            }
          ]
        }
      ]
    };
  },
  computed: {
    filteredAsideList() {
      if (!this.searchKeyword.trim()) return this.asideList;

      const keyword = this.searchKeyword.toLowerCase();
      return this.asideList.reduce((result, menuItem) => {
        // 检查主菜单标题匹配
        const mainTitleMatch = this.$t(`apiDoc.${menuItem.title}`)
          .toLowerCase()
          .includes(keyword);

        // 过滤匹配的子菜单
        const filteredSubItems = menuItem.subTitle.filter((subItem) =>
          this.$t(`apiDoc.${subItem.title}`).toLowerCase().includes(keyword)
        );

        // 保留匹配的主菜单（显示所有子项或仅匹配子项）
        if (mainTitleMatch || filteredSubItems.length > 0) {
          result.push({
            ...menuItem,
            subTitle: mainTitleMatch ? menuItem.subTitle : filteredSubItems
          });
        }
        return result;
      }, []);
    }
  },
  methods: {
    toIndexPath() {
      if (this.$route.path != "/apiDoc/index") {
        this.$router.push("/apiDoc/index");
        this.$refs.openApiMenu.activeIndex = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.api-menu-vertical {
  border-right: none;
  ::v-deep .el-submenu__title {
    font-weight: 600;
  }
  ::v-deep .el-menu-item {
    max-width: 100%;
    white-space: normal;
    display: flex;
    align-items: center;
    line-height: 1.2;
    &.is-active {
      font-weight: 600;
    }
  }
  ::v-deep .el-menu-item.is-active {
    font-weight: 600;
  }
}
.main-left-top {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.main-left-header {
  position: relative;
  width: 100%;
  border-bottom: 1px solid $table-border-color;
  color: #2b2d42;
  font-size: 26px;
  font-weight: 900;
  line-height: 26px;
  padding: 22px 0 22px 20px;
  box-sizing: border-box;
  cursor: pointer;
  background: #fff;
  .line {
    width: 4px;
    height: 28px;
    background: $theme-color;
    border-radius: 2px;
    display: inline-block;
    position: absolute;
    left: 0;
    top: 22px;
  }
}

.main-left-aside {
  box-sizing: border-box;
  flex: 1;
  overflow: auto;
  max-height: 700px;
  .main-left-aside-item {
    .title {
      font-size: 14px;
      color: #2b2d42;
      box-sizing: border-box;
      padding: 10px 20px;
      line-height: 14px;
    }
    .subTitle {
      font-size: 14px;
      font-weight: 400;
      color: #61666d;
      line-height: 50px;
      text-align: center;
      .subTitle_click {
        cursor: pointer;
        &:hover {
          color: $theme-color;
        }
      }
    }
  }
  .active {
    color: $theme-color;
  }
}
[dir="rtl"] .main-left-top {
  .main-left-header {
    padding: 22px 20px 22px 5px;
    .line {
      left: inherit;
      right: 0;
    }
  }
  .el-menu {
    padding: 0;
  }
}
[dir="rtl"] .main-left-top ::v-deep .el-submenu__icon-arrow {
  left: 20px;
  right: inherit;
}
.search-box {
  padding: 10px 15px;
  // border-bottom: 1px solid $table-border-color;
  background: #fff;
}

.empty-state {
  padding: 20px;
  text-align: center;
  color: #909399;
  font-size: 14px;
}
</style>
